import Repository from "../masterRepository";

const getTasklist = "/task-manager/project/gettasklist";

const getPages = "/uibuilder/getPages";
const updatePages = "/uibuilder/getPages";
const getSuitesData = "/uibuilder/getData";
const getRoles = "/uibuilder/getRoles";
const getUserStories = "/uibuilder/getUserStories";
const getDefaultPages = "/uibuilder/getDefaultPages";
const getProjectUserStories = "/project/getUserStories";
const getAssinTask = "/task-manager/task/getAssignTask";
const paginatedTasks = "/task-manager/task/getPaginatedTasks";
const saveRequirements = "/task-manager/task/save-requirement";
const getPagesComponents = "/cms/getClientCms";
const getStories = "/masters/stories/get";
const defaultProjectVersion = "/task-manager/project";
const addRolesToProject = "masters/roles/addRolesToProject";
const addPagesToProject = "masters/page/addPagesToProject";
const createProject = "/project/createProject";

export default {
  addRolesToProject(payload) {
    return Repository.post(`${addRolesToProject}`, payload);
  },
  addPagesToProject(payload) {
    return Repository.post(`${addPagesToProject}`, payload);
  },
  createProject(payload) {
    return Repository.post(`${createProject}`, payload);
  },
  getSuitesData(payload) {
    return Repository.post(`${getSuitesData}`, payload);
  },
  defaultProjectVersion(payload) {
    return Repository.post(`${defaultProjectVersion}`, payload);
  },
  getDefaultPages(payload) {
    return Repository.post(`${getDefaultPages}`, payload);
  },
  getStories(payload) {
    return Repository.post(`${getStories}`, payload);
  },
  getTasklist(payload) {
    return Repository.post(`${getTasklist}`, payload);
  },
  updatePages(payload) {
    return Repository.post(`${updatePages}`, payload);
  },
  getPages(payload) {
    return Repository.post(`${getPages}`, payload);
  },
  getRoles(payload) {
    return Repository.post(`${getRoles}`, payload);
  },
  getUserStories(payload) {
    return Repository.post(`${getUserStories}`, payload);
  },
  getProjectUserStories(payload) {
    return Repository.post(`${getProjectUserStories}`, payload);
  },
  getAssignTask(payload) {
    return Repository.post(`${getAssinTask}`, payload);
  },
  paginatedTasks(payload) {
    return Repository.post(`${paginatedTasks}`, payload);
  },
  saveRequirements(payload) {
    return Repository.post(`${saveRequirements}`, payload);
  },
  getPagesComponents(payload) {
    return Repository.post(`${getPagesComponents}`, payload);
  },
};
